export default {"src":"/_next/static/media/praia-dos-anjos-logo.5458ebc7.svg","height":89,"width":131,"blurWidth":0,"blurHeight":0};